<section class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">
      Ajouter des équipements
      <button class="btn btn-blue btn-lg float-end" routerLink="/mes-equipements/nouvel">
        <fa-icon [icon]="faPlus"></fa-icon> Ajouter un nouvel équipement
      </button>
    </h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    <form [formGroup]="form" (ngSubmit)="save()">
      @if (form.get('equipements'); as equipementsControl) {
        @for (group of asFormArray(equipementsControl).controls | groupBy:'value.item.categorie.nom'; track group) {
          <fieldset>
            @if (group.key; as categorie) {
              <legend>{{categorie}}</legend>
            }
            <div class="container-fluid">
              @for (item of group.items; track item) {
                @if (item.value; as checkbox) {
                  @if (checkbox.item; as equipement) {
                    <app-row-item [title]="equipement.nom" [disabled]="checkbox.disabled" (rowClick)="toggle(item)">
                      <ng-container prepend>
                        <fa-icon [icon]="item.get('checked').value ? faCheckSquare : faSquare" size="lg"
                        class="check me-3"></fa-icon>
                        <input class="d-none" type="checkbox" [value]="checkbox.value"
                          [formControl]="item.get('checked')">
                        <div class="thumbnail-circle me-3"
                        [style.backgroundImage]="equipement.image ? 'url(' + (equipement.image.url | backResource) + ')' : ''"></div>
                      </ng-container>
                      <ng-container actions>
                        <a ngbDropdownItem [routerLink]="'/equipement-global/' + equipement.id">Visualiser</a>
                        <button type="button" [disabled]="checkbox.disabled" ngbDropdownItem (click)="toggle(item)">{{item.get('checked').value ? 'Désélectionner' : 'Sélectionner' }}</button>
                      </ng-container>
                    </app-row-item>
                  }
                }
              }
            </div>
          </fieldset>
        }
      }


      <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
        <a class="btn btn-light" routerLink="/mes-equipements">Annuler</a>&nbsp;
        <button type="submit" class="btn btn-blue" [disabled]="loaderService.loading | async" matomoClickCategory="Equipements" matomoClickAction="click" matomoClickName="equipements_edit_enregistrer">Enregistrer</button>
      </nav>
    </form>
  </div>
</section>
